import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-ticket-create',
  templateUrl: './ticket-create.component.html',
  styleUrls: ['./ticket-create.component.scss']
})
export class TicketCreateComponent implements OnInit {
  ticketForm!: FormGroup;
  attachments: File[] = [];
  attachmentError = '';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private supportService: SupportService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    if (localStorage.getItem('role') === 'admin') {
      this.router.navigate(['/support']);
      return;
    }

    this.ticketForm = this.fb.group({
      subject: ['', [Validators.required]],
      category: ['general'],
      priority: ['normal'],
      description: ['', [Validators.required]]
    });
  }

  onFileSelect(event: Event) {
    this.attachmentError = '';
    const input = event.target as HTMLInputElement;
    if (!input.files) { return; }

    const newFiles = Array.from(input.files);
    const combined = [...this.attachments, ...newFiles];

    if (combined.length > 5) {
      this.attachmentError = 'Maximum 5 attachments allowed.';
      return;
    }

    for (const file of combined) {
      if (file.size > 10 * 1024 * 1024) {
        this.attachmentError = `File "${file.name}" exceeds the 10 MB limit.`;
        return;
      }
    }

    this.attachments = combined;
    input.value = '';
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
    this.attachmentError = '';
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) { return bytes + ' B'; }
    if (bytes < 1024 * 1024) { return (bytes / 1024).toFixed(1) + ' KB'; }
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  onSubmit() {
    if (this.ticketForm.invalid) {
      this.ticketForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const formData = new FormData();
    const values = this.ticketForm.value;
    formData.append('subject', values.subject);
    formData.append('category', values.category);
    formData.append('priority', values.priority);
    formData.append('description', values.description);

    this.attachments.forEach(file => {
      formData.append('attachments', file, file.name);
    });

    this.supportService.createTicket(formData).subscribe(
      (res: any) => {
        this.loading = false;
        this.toastr.success('Ticket created successfully');
        const ticket = res?.response?.data?.ticket || res?.response?.data;
        if (ticket && ticket._id) {
          this.router.navigate(['/support/tickets', ticket._id]);
        } else {
          this.router.navigate(['/support']);
        }
      },
      (err: any) => {
        this.loading = false;
        this.toastr.error(err?.error?.response?.message || 'Failed to create ticket');
      }
    );
  }

  goBack() {
    this.router.navigate(['/support']);
  }
}
